export default {"src":"/_next/static/image/public/images/ic_radio_hc_checked.11ea5bde505f05d727656760cc56ffe7.svg","height":24,"width":24};